import { ref } from 'vue';
import { defineStore } from 'pinia';
import { NOTIFICATION_TYPES } from '@/constants/messages';
/**
 * トーストメッセージ用の状態管理ストア
 */
export const useNotificationStore = defineStore('notification', () => {
  // --- State ---
  const msgState = ref(''); //表示する内容
  const type = ref('error'); //  'error' | 'success' | 'info'
  const isShow = ref(false); // 表示・非表示
  const timeoutId = ref(null); // タイマー動作確認用

  // --- Actions ---
  const showMsg = (msg, msgType = 'error', duration = 3000) => {
    // 連続クリック対策
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
    }

    msgState.value = msg;
    type.value = msgType;
    isShow.value = true;

    timeoutId.value = setTimeout(() => {
      isShow.value = false;
      timeoutId.value = null;
    }, duration);
  };

  // ショートカット関数
  const success = (msg) => showMsg(msg, NOTIFICATION_TYPES.SUCCESS);
  const error = (msg) => showMsg(msg, NOTIFICATION_TYPES.ERROR);
  const info = (msg) => showMsg(msg, NOTIFICATION_TYPES.INFO);
  // コンポーネントで使用
  return {
    msgState,
    type,
    isShow,
    showMsg,
    success,
    error,
    info,
  };
});
